let env = ''
if (process.env.CUSTOM_ENV === 'test') {
  env = 'test.'
} else if (process.env.CUSTOM_ENV === 'dev') {
  env = 'dev.'
} else if (process.env.CUSTOM_ENV === 'beta') {
  env = 'beta.'
}
export default {
  title: '汇成百年',
  favivon: '/favicon.ico',
  appName: '获客管理APP',
  aiAgent: false,
  ossUrl: 'https://oss.hcbnjyai.com',
  VUE_APP_HUOSHAN_PSSTERURI: 'https://cover.hcbnjyai.com/', // 火山封面图
  VUE_APP_BASE_AI_URL: 'wss://webhok.hcbnjyai.com/newApi', // AI助手 Socket url
  VUE_APP_ACTIVATION_URL: 'https://ap.hcbnjyai.com/share?orderNo=',
  VUE_APP_QUESTIONNAIRE_URL: `https://ap.hcbnjyai.com/questionnaire?id=`,
  VUE_APP_H5_URL: `https://h5.hcbnjyai.com/`,
  VUE_APP_TEMPLATE_URL: 'https://ap.hcbnjyai.com',
  VUE_APP_BASE_URL: 'https://webhok.hcbnjyai.com/',
  CLOUD_URL: `https://${env}cloud.hcbnjyai.com`,
  WELCOME_URL: 'https://vv.hcbnjyai.com/BDXfqy',
  publicKey:
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYWhrs6c7svOFn1iqqGeehVYB60gBSkI8j5Z6slXQQUiDkr90cz7qwgeKFtK5oi2BF4P5nf9nLLfwd8AMPiN+8EEirvPvWKZYfb2FRDzsLNojDIaY6Zc/wao7/sVymZszJ2dk7MyFfVkkPTJ3ZEW0ka9TUVnf473QON4GVUnKwPQIDAQAB',
  downloadMocMedia:
    'https://oss.hcbnjyai.com/yijianfabu/huicheng-trader-client.dmg?t=',
  downloadAndriodMedia:
    'https://oss.hcbnjyai.com/yijianfabu/huicheng-trader-client.exe?t=',
  downloadMacLive: 'https://oss.hcbnjyai.com/common/hcbnLive-macOS.dmg?t=',
  downloadAndriodLive:
    'https://oss.hcbnjyai.com/common/hcbnLive_release.exe?t=',
  QUESION_URL: `https://hcwq.fxyvv.com`
}
